export enum RetailerReducerErrors {
  RETAILER_NOT_FOUND = 'RETAILER_NOT_FOUND',
  REQUIRED_INTERMEDIARY_ACCOUNT_TO_CHANGE_DEBT_FUNDING_PACK = 'REQUIRED_INTERMEDIARY_ACCOUNT_TO_CHANGE_DEBT_FUNDING_PACK'
}
